// extracted by mini-css-extract-plugin
export default {"btn":"offersPage_btn__RkPLS"};